export const SIGN_OUT_USER = '@@user/signOut'

export const COOKIE_NAME = '_sphere_session'

export const REVOKE_TOKEN = '@@user/revokeToken'
